/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Event_Group_LabelInputs */

const en_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group`)
};

const fr_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements`)
};

const de_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe`)
};

const it_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi`)
};

const ru_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий`)
};

const es_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

const zh_cn2_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप`)
};

const pt_pt2_image_export_event_group_label = /** @type {(inputs: Image_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {Image_Export_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_event_group_label = /** @type {((inputs?: Image_Export_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_event_group_label(inputs)
	if (locale === "de") return de_image_export_event_group_label(inputs)
	if (locale === "it") return it_image_export_event_group_label(inputs)
	if (locale === "ru") return ru_image_export_event_group_label(inputs)
	if (locale === "es") return es_image_export_event_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_event_group_label(inputs)
	if (locale === "ja") return ja_image_export_event_group_label(inputs)
	if (locale === "hi") return hi_image_export_event_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_event_group_label(inputs)
	return en_image_export_event_group_label(inputs)
});